<section class="py-10 text-secondary dark:text-[#F2F2F2] text-sm leading-relaxed">
  <div class="relative z-10 h-[280px] mt-[-8.25rem] bg-[#EFF5FD] dark:bg-primary-dark">
    <div class="absolute inset-0 z-20 flex flex-col gap-4 items-center justify-center mt-10">
      <div class="mt-20 flex flex-col items-center gap-4">
        <app-back />
        <h4 class="text-secondary dark:text-white text-2xl md:text-4xl font-bold">
          {{ "Terms_Use.Page_Title" | translate }}
        </h4>

        <h3 class="text-muted dark:text-grey-dark text-xs lg:text-base w-80 md:w-full">
          {{ "Terms_Use.Page_Subtitle" | translate }}
          <a routerLink="/contact-us" class="text-brand font-medium">
            {{ "Contact.Contact_Email" | translate }}
          </a>
        </h3>
      </div>
    </div>
  </div>

  <div class="mt-6 container max-w-full mx-auto px-4 cw:px-[max(32px,calc((100%_-_1328px)/2))]">
    <p class="mb-6">
      {{ "Terms_Use.Intro" | translate }}
    </p>

    <ol class="list-decimal pl-5 text-base space-y-4 mt-2" [ngClass]="{ 'pr-5': isRTL }">
      <li>
        <h2 class="font-medium text-xl mb-3">
          {{ "Terms_Use.Section_One_Title" | translate }}
        </h2>
        <p>
          {{ "Terms_Use.Section_One_Description" | translate }}
        </p>
      </li>

      <li>
        <h2 class="font-medium text-xl mb-2">
          {{ "Terms_Use.Section_Two_Title" | translate }}
        </h2>
        <p>{{ "Terms_Use.You_Must" | translate }}</p>
        <ul class="list-disc pl-5 space-y-1" [ngClass]="{ 'pr-5': isRTL }">
          <li>{{ "Terms_Use.Section_Two_Point_One" | translate }}</li>
          <li>{{ "Terms_Use.Section_Two_Point_Two" | translate }}</li>
          <li>{{ "Terms_Use.Section_Two_Point_Three" | translate }}</li>
        </ul>
      </li>

      <li>
        <h2 class="font-medium text-xl">
          {{ "Terms_Use.Section_Three_Title" | translate }}
        </h2>
        <ul class="list-disc pl-5 mt-3 space-y-1" [ngClass]="{ 'pr-5': isRTL }">
          <li>{{ "Terms_Use.Section_Three_Point_One" | translate }}</li>
          <li>{{ "Terms_Use.Section_Three_Point_Two" | translate }}</li>
          <li>{{ "Terms_Use.Section_Three_Point_Three" | translate }}</li>
        </ul>
      </li>

      <li>
        <h2 class="font-medium text-xl">
          {{ "Terms_Use.Section_Four_Title" | translate }}
        </h2>
        <ul class="list-disc pl-5 mt-3 space-y-1" [ngClass]="{ 'pr-5': isRTL }">
          <li>{{ "Terms_Use.Section_Four_Point_One" | translate }}</li>
          <li>{{ "Terms_Use.Section_Four_Point_Two" | translate }}</li>
          <li>{{ "Terms_Use.Section_Four_Point_Three" | translate }}</li>
        </ul>
      </li>

      <li>
        <h2 class="font-medium text-xl mb-2">
          {{ "Terms_Use.Section_Five_Title" | translate }}
        </h2>
        <p>{{ "Terms_Use.Agree_Not" | translate }}</p>
        <ul class="list-disc pl-5 space-y-1" [ngClass]="{ 'pr-5': isRTL }">
          <li>{{ "Terms_Use.Section_Five_Point_One" | translate }}</li>
          <li>{{ "Terms_Use.Section_Five_Point_Two" | translate }}</li>
          <li>{{ "Terms_Use.Section_Five_Point_Three" | translate }}</li>
        </ul>
      </li>

      <li>
        <h2 class="font-medium text-xl">
          {{ "Terms_Use.Section_Six_Title" | translate }}
        </h2>
        <ul class="list-disc pl-5 mt-3" [ngClass]="{ 'pr-5': isRTL }">
          <li>{{ "Terms_Use.Section_Six_Point_One" | translate }}</li>
          <li>{{ "Terms_Use.Section_Six_Point_Two" | translate }}</li>
        </ul>
      </li>

      <li>
        <h2 class="font-medium text-xl">
          {{ "Terms_Use.Section_Seven_Title" | translate }}
        </h2>
        <ul class="list-disc pl-5 mt-3" [ngClass]="{ 'pr-5': isRTL }">
          <li>{{ "Terms_Use.Section_Seven_Point_One" | translate }}</li>
          <li>{{ "Terms_Use.Section_Seven_Point_Two" | translate }}</li>
        </ul>
      </li>

      <li>
        <h2 class="font-medium text-xl mb-2">
          {{ "Terms_Use.Section_Eight_Title" | translate }}
        </h2>
        <p>{{ "Terms_Use.Liable_For" | translate }}</p>
        <ul class="list-disc pl-5" [ngClass]="{ 'pr-5': isRTL }">
          <li>{{ "Terms_Use.Section_Eight_Point_One" | translate }}</li>
          <li>{{ "Terms_Use.Section_Eight_Point_Two" | translate }}</li>
          <li>{{ "Terms_Use.Section_Eight_Point_Three" | translate }}</li>
        </ul>
      </li>

      <li>
        <h2 class="font-medium text-xl mb-2">
          {{ "Terms_Use.Section_Nine_Title" | translate }}
        </h2>
        <p>
          {{ "Terms_Use.Section_Nine_Description" | translate }}
        </p>
      </li>

      <li>
        <h2 class="font-medium text-xl">
          {{ "Terms_Use.Section_Ten_Title" | translate }}
        </h2>
        <ul class="list-disc pl-5 mt-3" [ngClass]="{ 'pr-5': isRTL }">
          <li>{{ "Terms_Use.Section_Ten_Point_One" | translate }}</li>
          <li>{{ "Terms_Use.Section_Ten_Point_Two" | translate }}</li>
        </ul>
      </li>

      <li>
        <h2 class="font-medium text-xl mb-2">
          {{ "Terms_Use.Section_Eleven_Title" | translate }}
        </h2>
        <p>
          {{ "Terms_Use.Section_Eleven_Description" | translate }}
        </p>
      </li>
    </ol>

    <h4 class="p-2">
      {{ "Terms_Use.Agreement_Notice" | translate }}
    </h4>
  </div>
</section>